// tslint:disable
export var TCSDocumentType;
(function (TCSDocumentType) {
    // None
    TCSDocumentType[TCSDocumentType["None"] = 0] = "None";
    // Claim
    TCSDocumentType[TCSDocumentType["Claim"] = 1] = "Claim";
    // Correspondence
    TCSDocumentType[TCSDocumentType["Correspondence"] = 2] = "Correspondence";
})(TCSDocumentType || (TCSDocumentType = {}));
TCSDocumentType['NONE'] = 0;
TCSDocumentType['CLAIM'] = 1;
TCSDocumentType['CORRESPONDENCE'] = 2;
//# sourceMappingURL=TCSDocumentType.js.map